import React from 'react';
import './style.css';

const index = () => {

    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }

  return (
        <div className="component-desc">
            <h2 className="heading">Avatar</h2>
            <div className="description">An avatar is used to represent the user's profile picture or their initials.</div>
            <div className="divider"></div>
            <h4 className="heading">Circular Avatars</h4>
            <div className="avatar-container">
                <img src="/images/avatar.png" alt="Avatar" className="avatar-circular avatar-sm" />
                <img src="/images/avatar.png" alt="Avatar" className="avatar-circular avatar-md" />
                <img src="/images/avatar.png" alt="Avatar" className="avatar-circular avatar-lg" />
            </div>  
            <div className="carbon-container">
                <iframe className="iframe"
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cimg%2520src%253D%2522static%252Fimages%252Favatar.png%2522%2520alt%253D%2522Avatar%2522%2520class%253D%2522avatar-circular%2520avatar-sm%2522%253E%250A%253Cimg%2520src%253D%2522static%252Fimages%252Favatar.png%2522%2520alt%253D%2522Avatar%2522%2520class%253D%2522avatar-circular%2520avatar-md%2522%253E%250A%253Cimg%2520src%253D%2522static%252Fimages%252Favatar.png%2522%2520alt%253D%2522Avatar%2522%2520class%253D%2522avatar-circular%2520avatar-lg%2522%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
            <div className="divider"></div>
            <h4 className="heading">Rounded Avatars</h4>
            <div className="avatar-container">
                <img src="/images/avatar.png" alt="Avatar" className="avatar-rounded avatar-sm"/>
                <img src="/images/avatar.png" alt="Avatar" className="avatar-rounded avatar-md" />
                <img src="/images/avatar.png" alt="Avatar" className="avatar-rounded avatar-lg" />
            </div> 
            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cimg%2520src%253D%2522static%252Fimages%252Favatar.png%2522%2520alt%253D%2522Avatar%2522%2520class%253D%2522avatar-rounded%2520avatar-sm%2522%253E%250A%253Cimg%2520src%253D%2522static%252Fimages%252Favatar.png%2522%2520alt%253D%2522Avatar%2522%2520class%253D%2522avatar-rounded%2520avatar-md%2522%253E%250A%253Cimg%2520src%253D%2522static%252Fimages%252Favatar.png%2522%2520alt%253D%2522Avatar%2522%2520class%253D%2522avatar-rounded%2520avatar-lg%2522%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
        </div>
  )
}

export default index